import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'

export const Empty = styled.div`
	background-color: ${helpers.color.input.menuBackground};
	color: ${helpers.color.input.menuEmpty};
	text-align: center;
	padding: 12px;
	border-radius: 4px;
`
